<!--实时电能质量,三相电压和不平衡度-->
<template>
    <div class="myvirtualDeviceRTCurve">
       <div class="con">
            <div class="tree-left">
                <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
		      	</div>
             <div class="right-table">
                  <div class="Files-top">
                        <div class="ic-left">
                        <span>实时曲线</span>
                        </div>
                        <div class="btns">
                        <el-button  @click="downloadExcel" type="primary" class="last-el-button">导出</el-button>
                        </div>
                  </div>
                   <div class="search-input-btn" style="width:100%">
                        <div class="input-small">
                        <span>应用类型组：</span>
                          <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择">
                            <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                            <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </div>
                   </div>
                    <div class="myradio-group">
                         <div :class="['item', 'item1',{'item-active':tabPosition == 'top'}]" @click="tabPosition = 'top'">折线</div>
                         <div :class="['item', 'item2',{'item-active':tabPosition == 'left'}]" @click="tabPosition = 'left'">柱状</div>
                    </div>
                     <vchart ref='vchart' style="height: 55%" v-show="tabPosition == 'top'"></vchart>
                     <vchart ref='vchart2' style="height: 55%" v-show="tabPosition == 'left'"></vchart>
                       <div class="Files-table" :style="{'height':heights+'px'}">
                    <el-table :height="heights - 20" :data="nowPage" border>
                        <template slot="empty">
                          <span class="noData">
                            <img src="@/assets/noData.png" alt="暂无数据">
                            <span class="text">暂无数据</span>
                          </span>
                        </template>
                        <el-table-column type="index" width="90" label="序号" align="center"></el-table-column>
                        <el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name"
                          :key="item.key"></el-table-column>
                      </el-table>
                     </div>
                   <div class="divider-line"></div>
                     <div class="paging"> 
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                            :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]" :page-size="15"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                          </el-pagination>
                  </div>


		      	</div>


       </div>

    </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'

     import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  export default {
    components: {
      vchart,
      elUnitTree,

    },
    props: {},
    data () {
      return {
         heights: document.getElementById('app').clientHeight-750,
        tabPosition: 'left',
        apptypeValue: [],
        nowIndex: 0,
        from2name: {},
        nowApptypeGroups: [],
        nowSeries: [],
        refreshInterval: 2000,
        columns: [{
          name: '设备名称',
          key: 'devicename'
        },{
          name: '变量名称',
          key: 'variablename'
        },{
          name: '实时值',
          key: 'value'
        }],
        options: {
          title: {
            text: "实时曲线(折线)",
            left: 'left',
            textStyle: {
              fontWeight: 500,
              fontSize: 16,
              color:"#1a1a1a"
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "30",
            feature: {
              magicType: {
                type: ['stack','tiled'],title: {
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },

              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },

          },
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: (params,ticket,callback) => {
              var label=new Date(params[0].data[0]).formatByTime()+"</br>"
              params.forEach(item => {
                var values;
                if(isnull(item.data[1])) {
                  values="无采集数据";
                } else {
                  values=cutDigital(item.data[1]);
                }
                label+=item.seriesName+" : "+values+"</br>"
              })
              return label;
            },
            axisPointer: {
              animation: false
            }
          },
          xAxis: {
            type: 'time',
            splitLine: {
              show: true
            }
          },
          yAxis: {
            type: 'value',
            max: value => {
              return Math.ceil(value.max)|0+10
            },
            boundaryGap: [0,'100%'],
            splitLine: {
              show: true
            }
          },
          grid: {
            left: '5%',
            right: '30',
            bottom: '70'
          },
          legend: {
            data: [],
            type: 'scroll',
            bottom: '20px',
            right: 30,
            formatter: function(name) {
              return echarts.format.truncateText(name,100,'14px Microsoft Yahei','…');
            },
            tooltip: {
              show: true
            },
            selected: {}
          },
          series: []
        },
         total: 0,
        currentPage: 1,
        currentSize: 10,
        nowVirtualDeviceList:[]
      }
    },
    created () {
      
    },
    mounted () {
      this.apptypeValue=this.nowSelectAppTypeGroupIds
      debugPage=this
      this.$refs.vchart.setData(this.options,true)
      this.$refs.vchart2.setData(this.options,true)
      addNewTask('refreshRealPowerQuality',1000,this.refreshInterval,-1,() => {
        this.addData()
      })
    },
    destroyed () {
      removeTask('refreshRealPowerQuality')
      this.realTimeValueStore.commit("removeKeys",this.variableNameList)
    },
    computed: {
      // nowVirtualDeviceList () {
      //   return this.$store.deviceStore.state.nowVirtualDeviceList
      // },
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      variableStore () {
        return this.$store.variableStore
      },
      archivesStore () {
        return this.$store.archivesStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      
      variableTree () {
        if(isempty(this.nowVirtualDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowVirtualDeviceList.forEach(item => {
          var variableTree=[]
          if(item.type=="virtualDevice") {
            if(variableTree.length==0) {
              variableTree=this.variableStore.getters.getVariableTree(item.no)
            }
          }
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
       
         //排序
        list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
        
         let idList=[]
          list.forEach(item => {
            idList.push(item.id)
          })
          this.apptypeValue=idList
        return list
      },
      variableNameList () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            this.from2name[i.fromName]=i.name+'('+item.unit+')'
            v2.push(i.fromName)
          })
        })
        return v2
      },
      nowVariableList () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            i.devicename=item.devicename
            v2.push(i)
          })
        })
        v2.sort((a,b) => {
          return a.typeNo-b.typeNo
        })

        return v2
      },
      pageLen () {
        return this.dataList.length<this.currentSize? this.dataList.length:this.currentSize
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        this.total = this.dataList.length
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        return list
      },
      dataList () {
        //获取值
        var vl=this.realTimeValueStore.getters.getValue(this.variableNameList)
        return this.variableNameList.map((item,index) => {
          var value=this.realTimeValueStore.getters.getText(item,vl[index])
          if(isNaN(parseFloat((value)))||isnull(parseFloat((value)))) {
            value='- -'
          }
          var name=this.from2name[item]? this.from2name[item]:item
          let deviceName=''
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              deviceName=item2.fromName.split('.')[0]
            }
          })
          return {
            devicename: deviceName,
            variablename: name.subByFirstChar("."),
            value,
          }
        })

      }
    },
    watch: {
   
      variableNameList (nv,ov) {

        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
        //重置缓存数据
        var list=[]
        var newLits=[]
        var dataList=[]
        var now=new Date().getTime()
        for(var i=0;i<20;i++) {
          dataList.unshift([now-this.refreshInterval*i,undefined])
        }
        nv.forEach((item,index) => {
          let deviceName=''
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              deviceName=item2.fromName.split('.')[0]
            }
          })
          var name=deviceName+"_"+item.subByFirstChar('.')
          list.push({
            name,
            fromName: item,
            type: 'line',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            symbol: 'emptyCircle',
            data: dataList.copy()
          })
          newLits.push({
            name,
            fromName: item,
            type: 'bar',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            symbol: 'emptyCircle',
            data: dataList.copy()
          })
        })
        this.nowSeries=list
        this.options.series=list
        var selected={}
        this.options.legend.data=
          nv.map((item,index) => {
            let deviceName=''
            this.nowVariableList.forEach(item2 => {
              if(item2.fromName==item) {
                deviceName=item2.fromName.split('.')[0]
              }
            })
            var name=deviceName+"_"+item.substr(item.indexOf('.')+1)
            if(index>5) {
              selected[name]=false
            }
            return {
              name: name,
              icon: 'roundRect'
            }
          })
        this.options.legend.selected=selected
        var columnar=JSON.parse(JSON.stringify(this.options))
        columnar.series=newLits
        columnar.title.text='实时曲线(柱状)'
        this.$refs.vchart.setData(this.options,true)
        this.$refs.vchart2.setData(columnar,true)
      },
      apptypeValue (nv,ov) {
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',nv)
        let list=[]
        if(!isempty(nv)) {
          nv.forEach(item => {
            this.apptypeGroups.forEach(item2 => {
              if(item==item2.id) {
                list.push(item2)
              }
            })
          })
        }
        this.nowApptypeGroups=list
      }
    },
    methods: {
        checkFun(val){
          this.nowVirtualDeviceList = val
        },
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 实时值'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"实时值报告")
      },
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=idList
        } else {
          this.nowApptypeGroup=[]
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }

      },
      addData () {
        //获取值
        if(this.$refs.vchart==undefined) {
          return
        }
        var vl=this.realTimeValueStore.getters.getValue(this.variableNameList)
        var now=new Date().getTime()
        this.nowSeries.forEach((item,index) => {
          item.data.shift()
          var temp=vl[index]
          if(isNaN(parseFloat((temp)))||isnull(parseFloat((temp)))) {
            temp=undefined
          }
          item.data.push([now,temp])
        })
        this.$refs.vchart.setData({
          series: this.nowSeries
        })
        var columnar=JSON.parse(JSON.stringify(this.nowSeries))
        columnar.forEach(item => item.type='bar')
        this.$refs.vchart2.setData({
          series: columnar
        })

      },
       //分页功能 
      handleSizeChange (val) {
        this.currentSize = val;
        // this.getList()
      },
      handleCurrentChange (val) {
        this.nowIndex = val - 1;
        // this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .myvirtualDeviceRTCurve {
      .con{
    width: 100%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
    .myradio-group {
      display: flex;
      position: absolute;
      top: 120px;
      right: 148px;
      z-index: 10;
      .item {
        width: 52px;
        height: 28px;
        border: 1px solid #e6e6e6;
        color: #999999;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
        &.item-active {
          border-color: #368ED9;
          color: #368ED9;
          background-color: #DEEFFE;
        }
      }
      .item1 {
        border-radius: 2px 0px 0px 2px;
        
      }
      .item2 {
        border-radius: 0px 2px 2px 0px;
      }
    }
  
  .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
     .tree-left {
				width: 3rem;
				height: 100%;
				padding: 12px;
				box-sizing: border-box;
				background-color: #fff;
				margin-right: 8px;
				.btns {
					display: flex;
					// justify-content: space-evenly;
					margin-bottom: 8px;

					button {
					margin-right: 12px;
					}

					.el-button--mini {
					padding: 7px 10px !important;
					}

					.el-button+.el-button {
					margin-left: 0px;
					}
				}

				.search {
					display: flex;
					justify-content: center;
					margin-bottom: 12px;
				}

				}
	    .right-table {
			width: calc(100% - 3.08rem);
			height: 100%;
			padding: 12px 20px 20px 20px; 
			box-sizing: border-box;
			background-color: #fff;
      position: relative;
      .mycharts {
        display: flex;
        .charts-left{
          width: 35%;
        }
        .charts-right{
          width: 70%;
        }
      }
		}
   }
  }
</style>